import axios from "axios";
const API = axios.create({ baseURL: "https://leaderboard-task-xj5e.onrender.com/api" });

export const fetchUsers = () => API.get("/users");
export const addUser = (name) => API.post("/users/add", { name });
export const claimPoints = (userId) => API.post("/users/claim", { userId });
export const fetchLeaderboard = () => API.get("/users/leaderboard");
export const fetchHistory = () => API.get("/history");